import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Settings as ManageIcon, Groups as SquadIcon, } from "@mui/icons-material";
import { Avatar, Box, Card, CardContent, Chip, Divider, IconButton, Stack, Typography, } from "@mui/material";
import { Link } from "react-router-dom";
import { PlayerListRow } from "../players/PlayerListRow";
var MAX_PLAYERS_TO_SHOW = 5;
export var SquadCard = function (_a) {
    var players = _a.players, teamId = _a.teamId, title = _a.title, _b = _a.canModify, canModify = _b === void 0 ? false : _b;
    var activePlayers = teamId ? players.filter(function (p) { return p.isActive; }) : players;
    var truncate = !!teamId;
    var showViewAll = truncate && activePlayers.length > MAX_PLAYERS_TO_SHOW;
    var playersToDisplay = truncate
        ? activePlayers.slice(0, MAX_PLAYERS_TO_SHOW)
        : activePlayers;
    return (_jsx(Card, { children: _jsxs(CardContent, { children: [_jsxs(Box, { sx: {
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        mb: 2,
                    }, children: [title ? (title) : (_jsxs(Box, { sx: { display: "flex", alignItems: "center", gap: 1 }, children: [_jsx(Typography, { variant: "h6", sx: { fontWeight: 600 }, children: "Squad" }), activePlayers.length > 0 && (_jsx(Chip, { label: activePlayers.length, size: "small", sx: {
                                        backgroundColor: "rgba(25, 118, 210, 0.1)",
                                        color: "primary.main",
                                        fontWeight: 600,
                                        minWidth: 24,
                                    } }))] })), canModify && teamId && (_jsx(IconButton, { component: Link, to: "/teams/".concat(teamId, "/squad/"), role: "button", size: "small", title: "Manage squad", sx: {
                                color: "text.secondary",
                                "&:hover": {
                                    backgroundColor: "rgba(0, 0, 0, 0.04)",
                                    transform: "scale(1.05)",
                                },
                                transition: "all 0.2s ease",
                            }, children: _jsx(ManageIcon, {}) }))] }), _jsx(Divider, { sx: { mb: 2 } }), _jsx(Stack, { spacing: 0, children: playersToDisplay.length > 0 ? (playersToDisplay.map(function (player, index) { return (_jsx(PlayerListRow, { player: player, showDivider: index < playersToDisplay.length - 1, leading: _jsx(Box, { sx: {
                                width: 28,
                                textAlign: "center",
                                mr: 1.5,
                                flexShrink: 0,
                            }, children: _jsx(Typography, { variant: "body2", sx: {
                                    fontWeight: 600,
                                    lineHeight: 1,
                                    color: "text.secondary",
                                }, children: player.squadNumber !== null &&
                                    player.squadNumber !== undefined
                                    ? player.squadNumber
                                    : "–" }) }) }, player.id)); })) : (_jsxs(Box, { sx: { p: 4, textAlign: "center" }, children: [_jsx(Avatar, { sx: {
                                    width: 56,
                                    height: 56,
                                    backgroundColor: "rgba(25, 118, 210, 0.1)",
                                    color: "primary.main",
                                    mx: "auto",
                                    mb: 2,
                                }, children: _jsx(SquadIcon, { sx: { fontSize: 28 } }) }), _jsx(Typography, { variant: "h6", color: "text.secondary", sx: { mb: 1 }, children: "No players yet" }), _jsx(Typography, { variant: "body2", color: "text.secondary", children: "Add players to build your squad" })] })) }), showViewAll && (_jsx(Box, { sx: {
                        p: 2,
                        textAlign: "center",
                        backgroundColor: "rgba(25, 118, 210, 0.02)",
                        borderTop: "1px solid rgba(0,0,0,0.08)",
                        mt: 1,
                    }, children: _jsx(Link, { to: "/teams/".concat(teamId, "/squad/"), style: { textDecoration: "none" }, children: _jsxs(Typography, { variant: "body2", sx: {
                                color: "primary.main",
                                fontWeight: 500,
                                "&:hover": {
                                    textDecoration: "underline",
                                },
                            }, children: ["View all ", activePlayers.length, " players \u2192"] }) }) })), teamId && (_jsx(Box, { sx: {
                        p: 2,
                        textAlign: "center",
                        backgroundColor: "rgba(25, 118, 210, 0.02)",
                        borderTop: "1px solid rgba(0,0,0,0.08)",
                        mt: showViewAll ? 0 : 1,
                    }, children: _jsx(Link, { to: "/teams/".concat(teamId, "/formation/"), style: { textDecoration: "none" }, children: _jsx(Typography, { variant: "body2", sx: {
                                color: "primary.main",
                                fontWeight: 600,
                                "&:hover": {
                                    textDecoration: "underline",
                                },
                            }, children: "Build a Formation \u2192" }) }) }))] }) }));
};
